import React, { useMemo } from "react";
import { MaterialOrderFilterType, valueToText } from "../../../../configs/filterTypes";
import { MATERIAL_ORDER_STATUS } from "../../../../data/enums";

export interface StatusProgressProps {
    status?: MATERIAL_ORDER_STATUS | string | null;
    className?: string;
}

const StatusProgress: React.FC<StatusProgressProps> = ({ status, className }) => {
    // Define the ordered list of statuses for the progress bar
    const materialOrderStatuses: MATERIAL_ORDER_STATUS[] = useMemo(
        () => [
            MATERIAL_ORDER_STATUS.OPEN,
            MATERIAL_ORDER_STATUS.IMPORTING,
            MATERIAL_ORDER_STATUS.RESTOCK,
        ],
        [],
    );

    const normalizedStatus = (status || "").toString() as MATERIAL_ORDER_STATUS;
    const isCancelled = normalizedStatus === MATERIAL_ORDER_STATUS.CANCELLED;
    const isCompleted = normalizedStatus === MATERIAL_ORDER_STATUS.RESTOCK;

    const currentIndex = useMemo(
        () => materialOrderStatuses.indexOf(normalizedStatus),
        [normalizedStatus, materialOrderStatuses],
    )

    const labels = useMemo(
        () => materialOrderStatuses.map((s) => valueToText(MaterialOrderFilterType, "status", s) || s),
        [materialOrderStatuses],
    );

    const getLabelClass = (i: number) => {
        if (isCancelled) return "tw-text-red-600 tw-font-semibold";
        if (currentIndex < 0) return "";
        if (i < currentIndex) return "tw-text-black tw-font-semibold";
        if (i === currentIndex) return "tw-text-black tw-font-semibold";
        return "tw-text-gray-600";
    };

    const getSegmentClass = (i: number) => {
        if (isCompleted) return "tw-bg-emerald-600";
        if (isCancelled) return "tw-bg-red-600";
        if (currentIndex < 0) return "tw-bg-secondary";
        if (i < currentIndex) return "tw-bg-emerald-600";
        if (i === currentIndex) return "tw-bg-orange-500";
        return "tw-bg-secondary";
    };

    return (
        <div className={className} style={{ width: "100%" }}>
            <div className="tw-w-full tw-flex tw-gap-1">
                {materialOrderStatuses.map((_, i) => (
                    <div key={i} className="tw-flex-1 tw-flex tw-flex-col tw-items-stretch">
                        <div
                            className={`tw-h-2 tw-rounded ${getSegmentClass(i)}`}
                            aria-hidden
                        />
                        <div className="tw-text-[12px] tw-mt-2 tw-text-center">
                            <span className={getLabelClass(i)}>
                                {labels[i]}
                            </span>
                        </div>
                    </div>
                ))}
            </div>

        </div>
    );
};

export default StatusProgress;